import React from 'react'
import { Field, reduxForm } from 'redux-form'
import clsx from 'clsx'
import DatePickerDropdownField from 'forms/shared/fields/date-picker-dropdown'
import TimePickerDropdownField from 'forms/shared/fields/time-picker-dropdown'
import ContactField from 'forms/shared/fields/contact'
import InputField from 'forms/shared/fields/input'

const inputClassName = 'block border text-sm border-grey-light w-full p-3 rounded-lg'

const MessageSpaceOwnerForm = () => {
  return (
    <div>
      <Field
        type="text"
        name="space"
        groupClassName="my-4"
        disabled={true}
        inputClassName={clsx(inputClassName)}
        component={InputField}
      />
      <b>I would to like to view this space on:</b>
      <div className="flex my-4 date-container">
        <Field
          type="dropdown"
          name="schedule"
          showIcon
          showText={false}
          pickerClassName="w-auto datepicker absolute left-12 z-10"
          boxClassName="w-11/12 border rounded-lg p-3 cursor-pointer"
          groupClassName="w-2/3 relative"
          inputClassName="pl-1 regular text-sm w-full"
          component={DatePickerDropdownField}
        />
        <Field
          type="dropdown"
          name="time"
          groupClassName="w-1/3 flex flex-col items-end relative"
          showText={false}
          showIcon
          pickerClassName="w-full datepicker absolute right-12 z-10"
          inputClassName="pl-1 regular text-sm w-full"
          component={TimePickerDropdownField}
        />
      </div>
      <Field
        type="text"
        name="fullName"
        groupClassName="my-4"
        disabled={true}
        inputClassName={clsx(inputClassName)}
        component={InputField}
      />
      <Field
        type="text"
        name="email"
        groupClassName="my-4"
        disabled={true}
        inputClassName={clsx(inputClassName)}
        component={InputField}
      />
      <Field
        type="tel"
        name="phone"
        groupClassName="my-4"
        inputClassName={clsx(inputClassName)}
        disabled={true}
        component={ContactField}
      />
    </div>
  )
}

export default reduxForm()(MessageSpaceOwnerForm)
